import React, { useEffect } from "react";

export default function usePageTitle(pageName) {
  useEffect(() => {
    document.title = `${pageName} - Aspen SR`;
  }, [pageName]);
}
